import { render, staticRenderFns } from "./RichTextToggle.vue?vue&type=template&id=d5d60146&"
import script from "./RichTextToggle.vue?vue&type=script&lang=ts&"
export * from "./RichTextToggle.vue?vue&type=script&lang=ts&"
import style0 from "./RichTextToggle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports